import config from 'configDir/index';
import { get } from './http';

const queryCompanyService = get('/business_account/queryCompany', config.userServiceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  queryCompanyService,
};
